import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { UnauthenticatedContainerComponent } from './components/unauthenticated-container/unauthenticated-container.component';
import { CookieGuard } from '../authenticated/services/guards/cookie.guard';
import { CreateAccountComponent } from './components/create-account/create-account.component';
import { LinkCardComponent } from './components/link-card/link-card.component';

const routes: Routes = [
  {
    path: '',
    component: UnauthenticatedContainerComponent,
    children: [
      { path: '**', pathMatch: 'full', redirectTo: 'welcome' },
      { path: '', component: WelcomeComponent },
      { path: 'addcard', component: LinkCardComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UnauthenticatedRoutingModule {}
